import { useEffect } from "react";
import { PageProps } from "./_app";
import { useRouter } from "next/router";

function Login(props: PageProps) {
    const router = useRouter();

    useEffect(() => {
        props.setIsLoading(true);

        router.push("/v2/auth/login");
    }, []);

    return null;
}

export default Login;
